<template>
  <div class="d-flex flex-wrap mb-2">
    <b-button
      :variant="activeTab === 0 ? 'bg-primary' : 'bg-white'"
      class="mr-1 mb-1"
      @click="changeActiveTab(0)"
    >
      Charts
    </b-button>
    <b-button
      :variant="activeTab === 1 ? 'bg-primary' : 'bg-white'"
      class="mr-1 mb-1"
      @click="changeActiveTab(1)"
    >
      CPU
    </b-button>
    <b-button
      :variant="activeTab === 2 ? 'bg-primary' : 'bg-white'"
      class="mr-1 mb-1"
      @click="changeActiveTab(2)"
    >
      Network
    </b-button>
    <b-button
      :variant="activeTab === 3 ? 'bg-primary' : 'bg-white'"
      class="mr-1 mb-1"
      @click="changeActiveTab(3)"
    >
      Memory
    </b-button>
    <b-button
      :variant="activeTab === 4 ? 'bg-primary' : 'bg-white'"
      class="mr-1 mb-1"
      @click="changeActiveTab(4)"
    >
      File System
    </b-button>
  </div>
</template>
<script>
export default {
  name: 'HostDetailsSidebar',
  data() {
    return {
      activeTab: 0,
    }
  },
  methods: {
    changeActiveTab(val) {
      this.$emit('activeTab', val)
      this.activeTab = val
    },
  },
}
</script>
